
import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';

export class SocialLinkFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    maxLinks: number = 10;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = 'socialLinks';
    }
}
